import { getDeviationType } from '../DeviationViews/_helpers';
import { DeviationTypes } from '../types/deviation';
export function hasUserLists(deviation) {
    return ![
        DeviationTypes.COMMISSION,
        DeviationTypes.STATUS,
        DeviationTypes.POLL,
    ].includes(getDeviationType(deviation));
}
//# sourceMappingURL=helpers.js.map